<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <template v-if="data">
      <div class="topRect">
        <div class="title">
          {{ data.name }}
        </div>
        <van-rate v-model="data.score" size="1em" allow-half readonly class="star" :color="GetDiveMainBack()" /><span v-if="data.score<=0" class="noScore">暂无评分</span>
        <div class="addressLine">{{ data.country }}&nbsp;{{ data.zipString }}{{ data.address }}</div>
        <div class="addressLine" :style="'color:'+GetDiveMainBack()">{{ data.addressEng }}</div>
        <div class="mapRect">
          <baidu-map
            class="rectMap"
            :center="center"
            :zoom="zoom"
          >
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT" />
            <bm-marker :position="center" :dragging="false" />
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
            <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :show-address-bar="true" :auto-location="true" />
          </baidu-map>
        </div>
        <div class="about">{{ data.about }}</div>
      </div>
      <div v-if="data.ress && data.ress.length>0" class="baseRect">
        <div class="title">
          图片
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          PICTURE
        </div>
        <div class="about">
          <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(image, index) in data.ress" :key="index">
              <van-image
                width="100%"
                height="60vw"
                lazy-load
                fit="scale-down"
                :src="image"
              />
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="baseRect">
        <div class="title">
          潜点
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          DIVE POINT
        </div>
        <div v-if="divePlace.length<=0" class="emptyRect">
          暂无数据
        </div>
        <div class="dataRect">
          <div v-for="(item,index) in divePlace" :key="item.place.divePlaceId" class="rect" :style="index%2===0?'margin-right:0.5em':'margin-left:0.5em'">
            <van-image
              class="img"
              width="100%"
              height="30vw"
              lazy-load
              :src="item.place.resMain?item.place.resMain:'/dive/defaultDivePoint.jpg'"
              fit="cover"
              radius="0.4em"
              @click="onSelectPlace(item.place.divePlaceId)"
            />
            <div class="name" @click="onSelectPlace(item.place.divePlaceId)">{{ item.place.placeName }}</div>
          </div>
        </div>
      </div>

      <div class="baseRect">
        <div class="title">
          生物种类
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          BIOLOGICAL SPECIES
        </div>
        <div v-if="biologyList.length<=0" class="emptyRect">
          暂无数据
        </div>
        <div class="dataRect">
          <div v-for="(item,index) in biologyList" :key="item.biology.fishId" class="rect" :style="index%2===0?'margin-right:0.5em':'margin-left:0.5em'">
            <van-image
              class="img"
              width="100%"
              height="30vw"
              lazy-load
              :src="item.biology.img && item.biology.img.length>0?item.biology.img[0]:'/dive/defaultFish.jpg'"
              fit="cover"
              radius="0.4em"
              @click="onSelectFish(item.fishPlaceRelationId)"
            />
            <div class="name" @click="onSelectFish(item.fishPlaceRelationId)">{{ item.biology.name }}
            </div>
            <div class="from">
              <van-tag v-for="dp in item.divePlaceList" :key="dp.divePlaceId" plain :color="GetDiveMainBack()" @click="onSelectPlace(dp.divePlaceId)">{{ dp.placeName }}</van-tag>
            </div>
          </div>
        </div>
      </div>
      <div v-if="GetEnbaleDiveComment()" class="baseRect">
        <div class="title">
          点评
          <div style="float:right" @click="showAddComment=true"><i class="iconfont iconadd" /></div>
        </div>
        <div class="titleSmall" :style="'color:'+GetDiveMainBack()">
          REVIEWS
        </div>
        <diveCommentList v-model="commentId" :comment-type="commentType" />
        <diveCommentAdd v-model="showAddComment" :comment-id="commentId" :comment-type="commentType" />
      </div>
    </template>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Rate, Image, Lazyload, Tag, Swipe, SwipeItem } from 'vant'
import TopBar from '@/components/TopBar'
import { ShowMoney, GetEnumText, formatDate } from '@/utils/base'
import { GetEnbaleDiveComment, GetDiveMainBack, GetColorMain, GetColorSecondary, GetDiveTitle, GetColorMainLine } from '@/utils/base'
import diveCommentList from '@/components/diveCommentList'
import diveCommentAdd from '@/components/diveCommentAdd'
export default {
  components: {
    [Button.name]: Button,
    [Rate.name]: Rate,
    [Image.name]: Image,
    [Lazyload.name]: Lazyload,
    [Tag.name]: Tag,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    TopBar,
    diveCommentList,
    diveCommentAdd
  },
  data() {
    return {
      titleTop: '',
      title: '',
      backurl: '/dive/diveCenterList',
      id: undefined,
      data: undefined,
      divePlace: [],
      biologyList: [],
      testscore: 3,
      commentId: undefined,
      commentType: undefined,
      showAddComment: false,
      center: {
        lng: 116.403941, // 经度
        lat: 39.913948 // 纬度
      },
      zoom: 10
    }
  },

  created() {
    this.titleTop = GetDiveTitle()
    this.id = this.$route.params.id
    this.init()
    this.initDivePlace()
    this.initBiology()
  },
  methods: {
    GetEnbaleDiveComment,
    ShowMoney,
    GetColorMainLine,
    GetDiveMainBack,
    GetColorMain,
    GetColorSecondary,
    GetDiveTitle,
    GetEnumText,
    formatDate,
    init() {
      request({
        url: '/DiveData/getDiveCenter',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.title = this.data.name
        this.center.lat = this.data.lat
        this.center.lng = this.data.lng
        setTimeout(() => {
          this.commentType = 'DiveStore'
          this.commentId = this.id
        }, 1)
      })
    },
    initDivePlace() {
      request({
        url: '/DiveData/getDivePlaceList',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.divePlace = response.data
      })
    },
    initBiology() {
      request({
        url: '/DiveData/getBiologyList',
        method: 'post',
        data: { diveCenterId: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.biologyList = response.data
        this.biologyList.forEach(item => {
          if (item.biology.imgs) {
            item.biology.img = item.biology.imgs.split(',')
          }
        })
      })
    },
    onSelectFish(id) {
      this.$router.push('/dive/biology/' + id)
    },
    onSelectPlace(id) {
      this.$router.push('/dive/divePlace/' + id)
    }
  }
}
</script>
<style scoped>
.topRect{
    background-color: #fff;
    padding: 1em;
}
.title
{
    padding-top: 1em;
    font-weight: 700;
}
.titleSmall{
    font-size: 0.8em;
    font-weight: 700;
    padding-top: 0.25em;
    padding-bottom: 1em;
}
.topRect .star{
    padding: 0.5em 0;
}
.topRect .addressLine{
    font-size: 0.8em;
    font-weight: 700;
    padding: 0.25em 0;
}
.topRect .mapRect{
    width: 100%;
    height: 50vw;
    background-color: #ccc;
    margin: 1em 0;
}
.topRect .mapRect .rectMap{
  height: 50vw;
}
.topRect .about{
    font-size: 0.8em;
     color: #999;
}
.topRect .noScore{
    color: #999;
    font-size: 0.7em;
    margin-left: 0.5em;
}

.baseRect{
    padding: 0 1em;
    margin-top: 0.5em;
    background-color: #fff;
}

.dataRect{
    display: flex;
    flex-wrap: wrap;
}
.dataRect .rect{
    width: calc(50% - 0.5em);
    text-align: center;
    font-size: 0.8em;
    padding-bottom: 1em;

}
.dataRect .rect .img{
    overflow: hidden;
    margin-bottom: 0.5em;
}
.dataRect .name{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.dataRect .from{
    text-align: left;
}
.dataRect .from span{
    margin: 0.25em;
}
.emptyRect{
    line-height: 6em;
    text-align: center;
    color: #999;
    font-size: 0.8em;
}
</style>
